__turbopack_context__.v({
  "footer": "Footer-module__eQrXcW__footer",
});
